module.exports = __webpack_public_path__ + "static/media/a.5f4f9535.jpg";